const SolicitationType = {
    Base: 1,
    RTOP: 2,
    Other: 3,
    ARPA:5
}

export default SolicitationType;